export class VendorInvoiceChargeCode {
  id?: number;
  version?: number;

  allocationAmount: number;
  allocationPercent: number;
  taxAmount: number;

  invoiceItemId: number;
  chargeCodeId: number;
  accountId: number;
  chargeNumber: string;
  chargeCodeOwnerName: string;
  billable: boolean;
  codeType: CodeType;
}

enum CodeType {
  DirectProject = 'DIRECT_PROJECT',
  IndirectProject = 'INDIRECT_PROJECT',
  Indirect = 'INDIRECT'
}